module.exports = __webpack_public_path__ + "static/media/rogue2.1a938d56.jpg";